import React from 'react';
import PropTypes from 'prop-types';
import {Field} from 'formik';
import useFormikSchema from '../hooks/useFormikSchema';
import {useState} from 'react';
import {isEmpty} from 'lodash';
import KeyboardDatePicker from '../components/KeyboardDatePicker.jsx';
import moment from 'moment';
import formatError, { formatErrorWithIcon } from '../utils/formatError';

const Comp = (myProps) => {
  const {field, form, invalidDateMessage, format, label, fieldProps, ...other} = myProps;
  const invalidMessage = invalidDateMessage || `${label} is invalid`;
  const dataTestId = fieldProps['data-testid'];
  const [displayDate, setDisplayDate] = useState('');

  const currentError = form.errors[field.name];
  const onAcceptDate = (dateMoment) => {
    if (isEmpty(field.value) || !moment(field.value).isSame(dateMoment)) {
      form.setFieldValue(field.name, dateMoment.format(format));
    }
  };
  const onBlur = (evt) => {
    if (isEmpty(evt.target.value)) {
      form.setFieldValue(field.name, '');
    }
  };

  const onChangeDate = (selectedDate, selectedValue) => {
    setDisplayDate(selectedValue);
    if (selectedDate?.isValid() || isEmpty(selectedValue)) {
      form.setFieldValue(field.name, selectedValue);
      return;
    }
    if (isEmpty(selectedValue)) {
      form.setFieldValue(field.name, '');
      form.setFieldError(field.name, '');
    } else if (form.touched[field.name]) {
      form.setFieldError(field.name, invalidMessage);
    } else {
      form.setFieldError(field.name, undefined);
    }
  };

  const onError = (error) => {
    if (!currentError && error !== currentError && !isEmpty(error) && form.touched[field.name]) {
      form.setFieldError(field.name, error);
    }
  };

  const finalHelperTextProps = currentError ? {
    ...other?.FormHelperTextProps,
    'role': 'alert',
    'aria-label': formatError( currentError ),
  } : other?.FormHelperTextProps;

  return (
    <KeyboardDatePicker
      {...other}
      data-testid={dataTestId}
      inputValue={displayDate}
      onAccept={onAcceptDate}
      onBlur={onBlur}
      onError={onError}
      label={label}
      helperText={formatErrorWithIcon(currentError)}
      FormHelperTextProps={finalHelperTextProps}
      error={!!currentError}
      format={format}
      onChange={onChangeDate}
      name={field.name} />
  );
};

Comp.propTypes = {
  field: PropTypes.object.isRequired,
  form: PropTypes.object.isRequired,
};

const FormikKeyboardDatePicker = (props) => {
  const {value, name, disabled, label, schema, gridProps, fieldProps, ...rest} = props;
  const {formattedLabel} = useFormikSchema(name, label, schema);

  return (
    <Field
      fieldProps={fieldProps}
      fullWidth
      label={formattedLabel}
      disabled={disabled}
      value={value}
      name={name}
      {...rest}
      component={Comp} />
  );
};

FormikKeyboardDatePicker.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  disabled: PropTypes.bool,
  name: PropTypes.string.isRequired,
  format: PropTypes.string,
  valueFormat: PropTypes.string,
  gridProps: PropTypes.object,
  fieldProps: PropTypes.object,
};


export default FormikKeyboardDatePicker;

